import React from "react";
import PropTypes from "prop-types";

const SmsStatus = (props) => {
	const { loading, message } = props;

	return (
		<>
			{loading && (
				<div className="sms-loading-screen">
					<div className="sms-loading-screen-loader" />
					<span className="sms-loading-screen-text">
						{message}
					</span>
				</div>
			)}
			{!loading && (
				<div className="sms-loading-screen">
					<div className="sms-loading-screen-success" />
					<i className="sms-loading-screen-success-icon" />
					<span className="sms-loading-screen-text">
						{message}
					</span>
				</div>
			)}
		</>
	);
};

SmsStatus.propTypes = {
	loading: PropTypes.bool,
	message: PropTypes.string.isRequired,
};

SmsStatus.defaultProps = {
	loading: false,
};

export default SmsStatus;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/SmsStatus.jsx